import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App, { preloadRoute } from './App.tsx'

// Routes are lazy chunks (see App.tsx). Load the landing route's chunk BEFORE the
// first render: the prerendered static HTML stays on screen until React can paint
// the real page, so hydration never flashes a blank frame.
preloadRoute(window.location.pathname).finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
